var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 101,
    viewBox: "0 0 120 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 120,
    height: 100,
    rx: 4,
    fill: "#FFD166"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 84.5L32 76.5L38.4 76.5L46.3 50.2C46.8333 48.4667 47.8173 47.0827 49.252 46.048C50.6867 45.0133 52.2693 44.4973 54 44.5L66 44.5C67.7333 44.5 69.3173 45.0173 70.752 46.052C72.1867 47.0867 73.1693 48.4693 73.7 50.2L81.6 76.5L88 76.5L88 84.5L32 84.5ZM46.8 76.5L73.2 76.5L66 52.5L54 52.5L46.8 76.5ZM56 36.5L56 16.5L64 16.5L64 36.5L56 36.5ZM79.8 46.4L74.1 40.7L88.3 26.6L93.9 32.2L79.8 46.4ZM84 64.5L84 56.5L104 56.5L104 64.5L84 64.5ZM40.2 46.4L26.1 32.2L31.7 26.6L45.9 40.7L40.2 46.4ZM16 64.5L16 56.5L36 56.5L36 64.5L16 64.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowAlert);
export default __webpack_public_path__ + "static/media/yellow_alert.f89fb8b7540d452d213a646d59b76612.svg";
export { ForwardRef as ReactComponent };